import { PrinterListItemDto } from './printer-list-item.dto';

export class PrinterListItem {
    readonly id: string;
    readonly name: string;
    readonly host: string;
    // Last-known roll geometry, recorded at the printer's previous print — not a live reading.
    readonly dpi: number;
    readonly labelWidthDots: number;
    readonly labelLengthDots: number;
    readonly isAdminDefault: boolean;
    readonly enabled: boolean;

    constructor(dto: PrinterListItemDto) {
        this.id = dto.id;
        this.name = dto.name;
        this.host = dto.host;
        this.dpi = dto.dpi;
        this.labelWidthDots = dto.labelWidthDots;
        this.labelLengthDots = dto.labelLengthDots;
        this.isAdminDefault = dto.isAdminDefault;
        this.enabled = dto.enabled;
    }
}
